import { Component, Output, EventEmitter, Input } from '@angular/core';
import { DocumentoNegociableService } from '../../services/documento-negociable/documento-negociable.service';

@Component({
  selector: 'app-selec-archivo',
  templateUrl: './selec-archivo.component.html',
  styleUrls: ['./selec-archivo.component.scss']
})
export class SelecArchivoComponent {

  @Output() cerrarVentanaArchivos: EventEmitter<boolean>;
  @Output() abrirVentanaPDF: EventEmitter<boolean>;
  tipoAdjunto : number;
  @Input() tipoEmision:string = '';
  constructor( private negociablesService: DocumentoNegociableService) { 
    this.abrirVentanaPDF = new EventEmitter();

    this.cerrarVentanaArchivos = new EventEmitter();

  }


  CerrarVentana(){
    this.cerrarVentanaArchivos.emit();
  }

  MetAbrirAdjuntarPDF(tipoAdjunto? : number){
    this.negociablesService.tipoAdjunto = tipoAdjunto;
    this.abrirVentanaPDF.emit();
  }

}
